"use client";

import { PropsWithChildren } from "react";
import { Container } from "@/components/container";
import { cn } from "@/utils/classnames";

type Props = {
  className?: string;
  collapsed?: boolean;
};

export const NavigationContainer = ({
  className,
  collapsed,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Container className={className}>
      <nav
        className={cn("flex items-center", {
          "min-h-14 md:min-h-18": collapsed,
          "mb-4 flex-col justify-center md:mb-0 md:min-h-18 md:flex-row md:justify-between":
            !collapsed,
        })}
      >
        {children}
      </nav>
    </Container>
  );
};
